import React, { lazy } from 'react';
import { Sun, Expand, Eye, Accessibility, Sparkles, Droplets } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    title: 'Brighter Bathroom',
    copy: 'Glass allows light to move through the space, helping bathrooms feel more open and inviting.',
    icon: Sun,
    image: 'https://cdn.magicpatterns.com/uploads/rqV7DnYYNfKLA7mQahLzQj/BrighterBathroom.png',
    imageAlt: "Bright, sunlit bathroom with frameless glass shower enclosure installed by Kosin's Glass"
  }, {
    title: 'Larger Visual Feel',
    copy: 'Clear shower glass avoids visual barriers and can make smaller bathrooms feel less confined.',
    icon: Expand,
    image: 'https://cdn.magicpatterns.com/uploads/45kN8wDFyWK8RuWd87amjZ/Larger_Visual_Feel.png',
    imageAlt: 'Open, airy bathroom with frameless walk-in glass shower that makes the space feel larger'
  }, {
    title: 'Shows Off Tile & Stone',
    copy: 'Frameless and clear glass designs let your tile, stone, fixtures and shower details remain visible.',
    icon: Eye,
    image: 'https://cdn.magicpatterns.com/uploads/cuXuKgU6x36z7MrUpH4j2U/Shows_Off_Tile__Stone.png',
    imageAlt: "Frameless glass shower showcasing pebble floor tile, stone niche and matte black hardware by Kosin's Glass"
  }, {
    title: 'Easier Access Options',
    copy: 'Walk-in, low-curb and barrier-free shower glass options can support easier entry and daily use.',
    icon: Accessibility,
    image: 'https://cdn.magicpatterns.com/uploads/wVkywk9UvyQ8sk9AiEVjv3/Easier_Access_Options.png',
    imageAlt: "Curbless walk-in shower with single fixed glass panel for barrier-free access by Kosin's Glass"
  }, {
    title: 'Easier Cleaning',
    copy: 'Smooth glass surfaces and optional protective coatings help reduce maintenance compared with older framed doors or shower curtains.',
    icon: Sparkles,
    image: 'https://cdn.magicpatterns.com/uploads/wDp3rzmVERFnmnNwBpJzS8/Easier_Cleaning.png',
    imageAlt: 'Hand wiping down a frameless glass shower door for easy cleaning'
  }, {
    title: 'Spa-Like Style',
    copy: 'A custom glass shower can turn an ordinary bathroom into a cleaner, more modern and more relaxing space.',
    icon: Droplets,
    image: 'https://cdn.magicpatterns.com/uploads/r5mwumAigP95GbBYuSVv8p/Spa-Like_Style.png',
    imageAlt: 'Warm, spa-like bathroom with frameless glass walk-in shower, soaking tub and natural light'
  }];
  return <section className="py-20 bg-white" data-id="element-1476">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1477">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1478">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1479">
            Why Homeowners Choose Glass Shower Enclosures
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1480">
          {benefits.map((benefit, i) => <div key={i} className="bg-gray-50 rounded-2xl border border-gray-100 hover:border-blue-100 transition-colors overflow-hidden flex flex-col scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1481">
              <div className="aspect-[16/10] overflow-hidden bg-gray-100" data-id="element-1482">
                <img src={benefit.image} alt={benefit.imageAlt} className="w-full h-full object-cover" loading="lazy" data-id="element-1483" />
              </div>
              <div className="p-8 flex-1" data-id="element-1484">
                <div className="inline-flex items-center gap-2 mb-4 text-primary" data-id="element-1485">
                  <benefit.icon className="w-5 h-5" data-id="element-1486" />
                  <span className="text-xs font-semibold uppercase tracking-wider" data-id="element-1487">
                    Benefit
                  </span>
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1488">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1489">{benefit.copy}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}